import {
MAPBOX_GEOCODE_REQUEST,
MAPBOX_GEOCODE_SUCCESS,
MAPBOX_GEOCODE_FAILURE,
} from './actions'

import { initialState } from './selectors'

export default (state = initialState, {type, payload, metadata}) => {
  switch (type) {


      case MAPBOX_GEOCODE_REQUEST:
        return {
          ...state,
          [metadata.delta]: {
            ...state[metadata.delta],
            status: 'REQUESTED'
          }
        }
      case MAPBOX_GEOCODE_SUCCESS:
        return {
          ...state,
          [metadata.delta]: {
            ...state[metadata.delta],
            status: 'SUCCESS',
            data: payload
          }
        }
      case MAPBOX_GEOCODE_FAILURE:
        return {
          ...state,
          [metadata.delta]: {
            ...state[metadata.delta],
            status: 'FAILURE',
            error: payload
          }
        }


    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/interface/store/departments/mapbox/reducer.js